import { AxiosResponse } from 'axios'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import { getType } from 'typesafe-actions'

import { apiCall } from '../../../utils/api'
import { withLoading } from '../../loading'

import { AccountUserActions } from './actions'
import { AccountingData, UserProfileData } from './types'

export function* fetchUserData() {
  // @ts-ignore
  return yield call(apiCall, {
    url: `/api/Users/Profile`,
    method: 'get'
  })
}

export function* fetchBillingData() {
  // @ts-ignore
  return yield call(apiCall, {
    url: `/api/Users/billing`,
    method: 'get'
  })
}

export function* loadUserInfo() {
  const { data }: AxiosResponse<UserProfileData> = yield fetchUserData()
  yield put(AccountUserActions.setData(data))
}

export function* loadBillingInfo() {
  const { data }: AxiosResponse<AccountingData> = yield fetchBillingData()
  yield put(AccountUserActions.setBillingData(data))
}

export function* loadUserAndBillingInfo() {
  const [data1, data2]: [AxiosResponse<UserProfileData>, AxiosResponse<AccountingData>] = yield all([
    fetchUserData(),
    fetchBillingData()
  ])

  yield put(AccountUserActions.setData(data1.data))
  yield put(AccountUserActions.setBillingData(data2.data))
}

export function* accountUserSagas() {
  yield all([takeLatest(getType(AccountUserActions.fetchUserData), withLoading('accountUser', loadUserInfo))])
  yield all([takeLatest(getType(AccountUserActions.fetchBillingData), withLoading('accountUser', loadBillingInfo))])
  yield all([
    takeLatest(getType(AccountUserActions.fetchUserAndBillingData), withLoading('accountUser', loadUserAndBillingInfo))
  ])
}
